import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const Remove = ({ onRemove, item, isDisabled = false }) => {
  const handleDeleteCLick = () => onRemove(item);

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={`tooltip-delete-button-${item?.id}`} style={{ margin: 0 }}>Delete Photo</Tooltip>}
      >
        <Button
          name="btnRemoveImage"
          onClick={handleDeleteCLick}
          disabled={isDisabled}
          size="sm"
          style={{
            borderTopLeftRadius: '0',
            borderBottomLeftRadius: '0',
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px',
          }}
        >
          <i className="far fa-trash-alt" aria-hidden="true" />
        </Button>
      </OverlayTrigger>
    </>
  );
};

Remove.propTypes = {
  isDisabled: PropTypes.bool,
  onRemove: PropTypes.func,
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
};

export default Remove;
